import axios from 'axios';
import { errorMessage, legacyMessage, genericError, isKnownCode } from './errors';

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, timeout: 90000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let bouncing = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && !bouncing) {
      bouncing = true;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/') window.location.href = '/';
      setTimeout(() => { bouncing = false; }, 1500);
    }
    return Promise.reject(err);
  }
);

export const saveSession = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};
export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
};
export const getStoredToken = () => localStorage.getItem('token');

// ---- Entitlements (UX gating only; the backend is the security authority) ----
export const getEntitlements = () => {
  const u = getStoredUser();
  return Array.isArray(u?.entitlements) ? u.entitlements : null; // null = unknown (legacy session)
};
export const hasEntitlement = (key) => {
  const u = getStoredUser();
  if (!u) return false;
  if (u.role === 'admin') return true;              // coach/admin bypass (matches backend)
  const ents = Array.isArray(u.entitlements) ? u.entitlements : null;
  if (ents === null) return true;                   // legacy session w/o entitlements -> don't hide
  return ents.includes(key);
};
export const getPackageInfo = () => {
  const u = getStoredUser() || {};
  return {
    package: u.package || null,
    variant: u.variant || null,
    grandfathered: !!u.grandfathered,
    status: u.subscription_status || null,
    entitlements: Array.isArray(u.entitlements) ? u.entitlements : [],
  };
};

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    if (d.code && isKnownCode(d.code)) return errorMessage(d.code, d.params || d);
    if (typeof d.message === 'string') return legacyMessage(d.message);
    if (d.code) return errorMessage(d.code, d.params || d);
  }
  if (typeof d === 'string') return legacyMessage(d);
  if (Array.isArray(d)) {
    const msg = d.map((x) => (x && typeof x.msg === 'string' ? x.msg : '')).filter(Boolean).join(' ');
    if (msg) return legacyMessage(msg);
  }
  return fallback || genericError();
};
